var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","dark":"","height":"130px","src":require("../assets/header-flower.jpg")}},[_c('v-app-bar-title',[_c('img',{attrs:{"src":require("../assets/logo-midas.png"),"height":"60","alt":""}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }